define('modules/form_editor/models/check_radio_option',['require','exports','module','backbone'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    defaults: {
      selected: false,
      text: "Item",
      socialBinding: "",
      valid: true,
      isItemRequired: false
    }
  });
});

